const iniciaRecebimentoInitialValues = (email, transferenciaGuid) => ({
    Email: email,
    AceitaTermos: false,
    Transferencia: {
        Guid: transferenciaGuid,
    },
});
export default iniciaRecebimentoInitialValues;
